import request from "@/utils/request";
// 政策
export function getForm() {
  return request({
    url: "/api/contact/get",
    method: "get",
  });
}